import cx from 'classnames'

import {
  SanityFilterGroup,
  SanityFilterGroupDisplay,
} from '@data/sanity/queries/types/modules'
import { UrlParameter } from '@lib/hooks'
import { Filter } from '@lib/product'

import Accordion from '@components/accordion'
import CollectionFilterOption from './filter-option'

interface CollectionFilterGroupProps {
  group: SanityFilterGroup
  onChange: (newParameters: UrlParameter[]) => void
  activeFilter?: Filter
}

const CollectionFilterGroup = ({
  group,
  activeFilter,
  onChange,
}: CollectionFilterGroupProps) => {
  const id = group._key
  const groupTotal = activeFilter?.values?.length ?? 0

  return (
    <Accordion
      id={id}
      className="first:border-t-0"
      title={
        <>
          <span id={`filter-group-${id}`}>
            {group.title}

            {groupTotal > 0 && (
              <span className="inline-block align-middle opacity-30 ml-2 text-xs">
                ({groupTotal})
              </span>
            )}
          </span>
        </>
      }
    >
      <div
        role="group"
        aria-labelledby={`filter-group-${id}`}
        className={cx('flex flex-wrap gap-y-4 justify-items-start mt-2', {
          'grid grid-cols-3 gap-4':
            group.display === SanityFilterGroupDisplay.GRID,
        })}
      >
        {group.options.map((option, index) => (
          <CollectionFilterOption
            key={index}
            option={option}
            activeFilter={activeFilter}
            isGrid={group.display === SanityFilterGroupDisplay.GRID}
            onChange={onChange}
          />
        ))}
      </div>
    </Accordion>
  )
}

export default CollectionFilterGroup
